<template>
  <div class="careers-events">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('careers-events-1') }}</h3>
        <h1>{{ $t('careers-events-2') }}</h1>
        <!-- <h2>{{ $t('careers-events-3') }}</h2> -->
      </div>
    </div>
    <div class="events-container">
      <a
        :href="e.url"
        target="_black"
        class="events-item"
        v-for="(e, i) in events"
        :key="`event-${i}`"
      >
        <div class="events-item-left">
          <div class="events-item-left-text">
            <h1 class="text-light">{{e[locale].date}}</h1>
            <h1 class="text-light">{{e[locale].year}}</h1>
          </div>
        </div>
        <div class="events-item-right">
          <div class="text-group">
            <h2>{{e[locale].title}}</h2>
            <p v-for="(t, j) in e[locale].texts" :key="`event-${i}-t-${j}`">{{t}}</p>
          </div>
          <span class="kcm">
            <span>Z</span>
          </span>
        </div>
      </a>
    </div>
    <Apply/>
  </div>
</template>

<script>
import Apply from './shared/Apply';
export default {
  components: {
    Apply
  },
  data() {
    return {
      events: [
        {
          bg: {
            date: '08 Април',
            year: '2019',
            title: 'Национални дни на кариерата',
            texts: ['гр. Пловдив, Пловдивски панаир, Конгресен център, щанд 48']
          },
          en: {
            date: '08 April',
            year: '2019',
            title: 'Национални дни на кариерата',
            texts: ['гр. Пловдив, Пловдивски панаир, Конгресен център, щанд 48']
          },
          url: 'https://goo.gl/maps/72ABNAAZtwF2'
        },
        {
          bg: {
            date: '17 Април',
            year: '2019',
            title: 'Стажове 2019',
            texts: [
              'гр. Пловдив, ТУ – София, филиал Пловдив',
              'ул. “Цанко Дюстабанов“ № 25 етаж 2, щанд 55'
            ]
          },
          en: {
            date: '17 April',
            year: '2019',
            title: 'Стажове 2019',
            texts: [
              'гр. Пловдив, ТУ – София, филиал Пловдив',
              'ул. “Цанко Дюстабанов“ № 25 етаж 2, щанд 55'
            ]
          },
          url: 'https://goo.gl/maps/qnqpNatemyt'
        }
      ]
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="scss" scoped>
.careers-events {
  position: relative;
  .row-1 {
    padding-left: $sidesPadding;
    padding-right: $sidesPadding;
  }
}
.events-container {
  padding-bottom: $sidesPadding;
  padding-left: $sidesPadding + $sidesPadding / 2;
  padding-right: $sidesPadding + $sidesPadding / 2;
  .events-item {
    align-items: center;
    cursor: pointer;
    display: flex;
    margin-bottom: 30px;
    .events-item-left {
      background-color: $bgColor2;
      height: 100px;
      max-width: 340px;
      min-width: 340px;
      padding: 20px;
      padding-left: $sidesPadding / 2;
      padding-right: $sidesPadding / 2;
      @include transform(translateX(30px) translateY(-5px));
      z-index: 1;
      width: 340px;
      .events-item-left-text {
        align-items: flex-end;
        border-right: 1px solid #fff;
        @extend %flex-center;
        flex-direction: column;
        padding: 0 20px;
        h1 {
          font-weight: 900;
          line-height: 36px;
          white-space: nowrap;
        }
        h1:last-child {
          font-size: 24px;
          line-height: 24px;
        }
      }
    }
    .events-item-right {
      background-color: rgba(220, 234, 239, 0.7);
      min-height: 135px;
      padding: 20px 110px 30px 80px;
      width: 100%;
      @include transition(all 0.6s $mainCubic);
      @include transform(translateX(-30px));
      .text-group {
        h2 {
          margin: 10px 0;
        }
        p {
          margin: 0;
        }
      }
      .kcm {
        @extend %flex-center;
        background-color: transparent;
        border-radius: 50%;
        font-size: 40px;
        height: 60px;
        position: absolute;
        right: 30px;
        top: 50%;
        @include transform(translateY(-50%));
        width: 60px;
        span {
          position: relative;
          z-index: 2;
          @include transition(all 0.6s $mainCubic);
        }
      }
      .kcm::before {
        border-radius: 50%;
        content: '';
        height: 70px;
        left: -5px;
        position: absolute;
        top: -5px;
        width: 70px;
        z-index: 1;
      }
      .kcm::after {
        border-radius: 50%;
        content: '';
        height: 80px;
        left: -10px;
        position: absolute;
        top: -10px;
        width: 80px;
        z-index: 1;
      }
    }
  }
  .events-item:hover {
    .events-item-right {
      background-color: rgba(220, 234, 239, 0.9);
      .kcm {
        animation: pulse 2s infinite;
        span {
          color: #fff;
        }
      }
      .kcm::before {
        animation: pulse 2s infinite;
        animation-delay: 0.3s;
      }
      .kcm::after {
        animation: pulse 2s infinite;
        animation-delay: 0.6s;
      }
    }
  }
}
@keyframes pulse {
  0% {
    background-color: rgba(22, 65, 148, 0);
  }
  50% {
    background-color: rgba(22, 65, 148, 0.5);
  }
  100% {
    background-color: rgba(22, 65, 148, 0);
  }
}
@media screen and (max-width: 1600px) {
  .careers-events {
    .row-1 {
      padding-left: $sidesPadding1600;
      padding-right: $sidesPadding1600;
    }
    .events-container {
      padding-bottom: $sidesPadding1600;
      padding-left: $sidesPadding1600 + $sidesPadding1600 / 2;
      padding-right: $sidesPadding1600 + $sidesPadding1600 / 2;
      .events-item {
        .events-item-left {
          padding-left: $sidesPadding1600 / 2;
          padding-right: $sidesPadding1600 / 2;
        }
      }
    }
  }
}
@media screen and (max-width: 1376px) {
  .events-container {
    // padding-bottom: $sidesPadding;
    // padding-left: $sidesPadding + $sidesPadding / 2;
    // padding-right: $sidesPadding + $sidesPadding / 2;
    .events-item {
      .events-item-left {
        max-width: 260px;
        min-width: 260px;
        width: 260px;
        .events-item-left-text {
          h1 {
            font-size: 26px;
            line-height: 32px;
          }
          h1:last-child {
            font-size: 20px;
            line-height: 24px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .careers-events {
    .row-1 {
      padding-left: $sidesPadding1280;
      padding-right: $sidesPadding1280;
    }
    .events-container {
      padding-bottom: $sidesPadding1280;
      padding-left: $sidesPadding1280 + $sidesPadding1280 / 2;
      padding-right: $sidesPadding1280 + $sidesPadding1280 / 2;
      .events-item {
        .events-item-left {
          padding-left: $sidesPadding1280 / 2;
          padding-right: $sidesPadding1280 / 2;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .careers-events {
    .row-1 {
      padding: $sidesPadding1280;
    }
    .events-container {
      padding: $sidesPadding1280;
      padding-top: 0;
      .events-item {
        position: relative;
        margin-bottom: 10vw;
        .events-item-left {
          height: initial;
          left: 0;
          max-width: initial;
          min-width: initial;
          padding: 10px 20px;
          position: absolute;
          top: 0px;
          width: 100%;
          @include transform(translateY(-50%));
          .events-item-left-text {
            border: none;
            justify-content: flex-start;
            flex-direction: row;
            text-align: left;
            padding: 0;
            h1:nth-child(1n) {
              font-size: 18px;
              line-height: 18px;
            }
            h1:first-child {
              margin-right: 5px;
            }
          }
        }
        .events-item-right {
          padding: 20px;
          min-height: initial;
          @include transform(initial);
          .kcm {
            background-color: rgba(22, 65, 148, 0.5);
            color: #fff;
            font-size: 26px;
            height: 40px;
            top: 0;
            width: 40px;
            z-index: 1;
          }
          .kcm::before {
            background-color: rgba(22, 65, 148, 0.5);
            height: 50px;
            width: 50px;
          }
          .kcm::after {
            background-color: rgba(22, 65, 148, 0.5);
            height: 60px;
            width: 60px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .careers-events {
    .row-1 {
      padding: $sidesPadding600;
    }
    .events-container {
      padding: $sidesPadding600;
      padding-top: 0;
      .events-item {
        flex-direction: column;
        position: relative;
        margin-bottom: 20px;
        .events-item-left {
          height: 40px;
          left: 0;
          max-width: initial;
          min-width: initial;
          padding: 10px 20px;
          position: static;
          top: 0px;
          width: 100%;
          @include transform(initial);
          .events-item-left-text {
            border: none;
            justify-content: flex-start;
            flex-direction: row;
            text-align: left;
            padding: 0;
            h1:nth-child(1n) {
              font-size: 18px;
              line-height: 18px;
            }
            h1:first-child {
              margin-right: 5px;
            }
          }
        }
        .events-item-right {
          padding: 10px 20px 20px;
          min-height: initial;
          position: static;
          @include transform(initial);
          .kcm {
            background-color: rgba(22, 65, 148, 0.5);
            color: #fff;
            font-size: 26px;
            height: 40px;
            top: 20px;
            width: 40px;
            z-index: 1;
          }
          .kcm::before {
            background-color: rgba(22, 65, 148, 0.5);
            height: 50px;
            width: 50px;
          }
          .kcm::after {
            background-color: rgba(22, 65, 148, 0.5);
            height: 60px;
            width: 60px;
          }
        }
      }
    }
  }
}
</style>
